import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск деталей при создании новой гарантийной заявки.
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'parts', 'warrantyParts', 'count'];
  }

  initialize() {
    this.timeout = null;
    this.renderedArticle = null;
  }

  connect() {
    this.shipmentPartId = parseInt(this.data.get('shipment_part_id'));
    this.orderPartId = parseInt(this.data.get('order_part_id'));
    this.partId = parseInt(this.data.get('part_id'));
    this.userId = parseInt(this.data.get('user_id'));
    this.aWarranty = !!(this.data.get('a_warranty'));

    this.inputTarget.addEventListener('change', () =>
      this.searchShipmentParts()
    );
    this.inputTarget.addEventListener('keydown', () =>
      this.searchShipmentParts()
    );
    this.inputTarget.addEventListener('paste', () =>
      this.searchShipmentParts()
    );

    if (this.inputTarget.value.length > 0) {
      this.searchShipmentParts();
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', () =>
      this.searchShipmentParts()
    );
    this.inputTarget.removeEventListener('keydown', () =>
      this.searchShipmentParts()
    );
    this.inputTarget.removeEventListener('paste', () =>
      this.searchShipmentParts()
    );
  }

  checkSelectedPart() {}

  renderLoader() {
    this.partsTarget.innerHTML = `<br><div class="loader is-pulled-left"></div>&nbsp;Ищем деталь среди ваших отгрузок и в нашей базе...`;
  }

  renderNotFound(article) {
    this.partsTarget.innerHTML = `<br><p class="content is-paddingless">Деталь «${article}» не найдена среди ваших отгрузок.</p>`;
  }

  renderPart(part) {
    const checked = this.partId === part.id;

    return `
      <div class="control">
        <label class="radio">
          <input type="radio" name="warranty[part_id]" value="${part.id}" ${checked ? 'checked' : ''}>
          ${part.brand} ${part.article} ${part.description}
        </label>
      </div>
    `;
  }

  renderPartFromObject(object, type) {
    const result = [object.purpose];
    const partIdVariable = type + 'PartId';
    const domName = type + '_part_id';

    for (const part of object.parts) {
      if (part.warranties_count >= part.quantity) {
        result.push(`
          <div class="control">
            <label class="radio has-text-line-through">
              ${part.name} &mdash; ${part.quantity}&times;${part.price}
            </label>
          </div>
        `);
      } else {
        const checked = this[partIdVariable] === part.id;

        result.push(`
          <div class="control">
            <label class="radio">
              <input data-action="click->user--search-parts-for-warranty#select"
                     data-user--search-parts-for-warranty-max-count-param="${part.quantity}"
                     data-kind="${type}"
                     type="radio"
                     name="warranty[${domName}]"
                     value="${part.id}" ${checked ? 'checked' : ''}>
              ${part.name} &mdash; ${part.quantity}&times;${part.price}
            </label>
          </div>
        `);
      }
    }

    return result.join('');
  }

  renderParts(parts) {
    let result = [];
    const simpleParts = [];
    const partsWithShipment = [];
    const partsWithOrders = [];
    for (const part of parts) {
      if (part.shipments.length > 0) {
        for (const shipment of part.shipments) {
          partsWithShipment.push(this.renderPartFromObject(shipment, 'shipment'));
        }
      }

      // if (part.orders.length > 0) {
      //   for (const order of part.orders) {
      //     partsWithOrders.push(this.renderPartFromObject(order, 'order'));
      //   }
      // }

      if (partsWithShipment.length === 0) {
        simpleParts.push(this.renderPart(part));
      }
    }

    if (partsWithShipment.length > 0) {
      result.push(`<p class="has-text-weight-bold">Выберите отгрузку:</p>`);
      result = [...result, ...partsWithShipment];
    }

    // if (partsWithOrders.length > 0) {
    //   if (result.length > 0) result.push('<br>');
    //
    //   result.push(`<p class="has-text-weight-bold">Выберите заказ, если нет ни одной отгрузки:</p>`);
    //   result = [...result, ...partsWithOrders];
    // }

    if (simpleParts.length > 0) {
      if (result.length > 0) result.push('<br>');

      result.push(`
      <br><p class="has-text-weight-bold">У вас нет отгрузок деталью.</p>
      `);
      // result = [...result, ...simpleParts];
    }

    this.partsTarget.innerHTML = result.join('');

    this.checkSelectedPart();
  }

  searchShipmentParts() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const article = this.inputTarget.value;
      const userId = this.userId;
      if (article.length > 2 && article !== this.renderedArticle) {
        this.renderLoader();

        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/warranties/search_parts.json?query=${article}&user_id=${userId}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderParts(data);
            } else {
              that.renderNotFound(article);
            }

            that.renderedArticle = article;
          },
          error: () => {
            alert('Ошибка при попытке найти детали по вашему запросу');
          },
        });
      }
    }, 400);
  }

  renderWarrantyParts(parts, type) {
    let result = [];

    if (type == "order"){
      result.push(`
      <p class="has-text-weight-bold">При необходимости добавьте в заявку другие детали из выбранного заказа:</p><br>
     `);
    } else {
      result.push(`
      <p class="has-text-weight-bold">При необходимости добавьте в заявку другие детали из выбранной отгрузки:</p><br>
     `);
    }


    for (const part of parts) {
      result.push(`
        <div class="columns" style="margin-bottom: 0;">
          <div class="column is-narrow" style="padding-top: 18px;">
            <div class="control">
              <label class="radio">
                <input type="checkbox" name="${type}_part_ids[]" value="${part.id}"}>
                ${this.truncateString(part.name)} &mdash; ${part.quantity}&times;${part.price}
              </label>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Количество</label>
              </div>
              <div class="control">
                <input style="width: 100px;"
                  value="${part.quantity}"
                  name="part_${part.id}_qty"
                  class="input has-text-centered"
                  min="1"
                  max="${part.quantity}"
                  type="number"
                  onkeyup="enforceMinMax(this)">
              </div>
            </div>
          </div>
        </div>
      `);
    }

    this.warrantyPartsTarget.innerHTML = result.join('');
  }

  select(event) {
    if (this.warrantyPartsTarget) {
      this.countTarget.max = event.params.maxCount
      this.countTarget.value = 1
      this.warrantyPartsTarget.innerHTML = "<p>При необходимости добавьте другие детали из отгрузки</p>";
      this.warrantyPartsTarget.innerHTML = this.warrantyPartsTarget.innerHTML + "<p>Деталь выбрана " + event.target.value + "</p>";
      const that = this;
      Rails.ajax({
        type: 'GET',
        url: `/warranties/search_warranty_parts.json?query=${event.target.value}&type=${event.target.dataset.kind}`,
        success: (data) => {
          if (data.length > 0) {
            that.warrantyPartsTarget.classList.remove('is-hidden');
            that.renderWarrantyParts(data, event.target.dataset.kind);
          } else {
            that.warrantyPartsTarget.innerHTML = ""
            that.warrantyPartsTarget.classList.add('is-hidden');
          }

        },
        error: () => {
          alert('Ошибка при попытке найти детали');
        },
      });
    }
  }

  truncateString(str, maxLength = 90) {
    if (str.length > maxLength) {
      return str.slice(0, maxLength) + '...';
    }
    return str;
  }
}
